import dayjs, { Dayjs } from 'dayjs';

export function dayjsToTimeString(dayjs: Dayjs): string | null {
  return dayjs.isValid() ? dayjs.format('HH:mm:ss') : null;
}

export function timeStringToDayjs(timeString: string): Dayjs | null {
  try {
    return dayjs(timeString, 'HH:mm:ss');
  } catch {
    return null;
  }
}

export function timeStringToDayjsWithTz(timeString: string, tz: string): Dayjs | null {
  try {
    return dayjs.tz(timeString, 'HH:mm:ss', tz);
  } catch {
    return null;
  }
}
